import { Component, OnInit } from '@angular/core';
import { AbstractGs } from 'projects/game-utils/src/lib/service/AbstractGs';

@Component({
  selector: 'heart',
  templateUrl: './heart.component.html',
  styleUrls: ['./heart.component.css']
})
export class HeartComponent implements OnInit {

  public visible:boolean = false;
  
  constructor(private gameService:AbstractGs) { }

  ngOnInit() {
  }

  public getHearts():number{
    return this.gameService.user.getLives();
  }

}
